import React from 'react'

import {Button, Card, Col, Drawer, Form, Icon, Tooltip, notification, Row, Select, Input} from 'antd'
import _ from 'lodash'
import styles from './styles.less'
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import {hideLoader, showLoader} from '../../modules/actions'
import Request from '../../request'
import {connect} from 'react-redux'

@Form.create()

class InvoiceStudentList extends React.Component {
    state = {
        visible: true,
        generatedInvoice: {},
        invoiceStatuses: [
            'Generated', 'Submitted to Uni', 'Approved by Uni', 'Paid by Uni', 'Cleared'
        ]
    }

    loadInvoiceDetail = async() => {
        const { invoiceId } = this.props;
        const res = await Request.getInvoiceDetail(invoiceId);
        if(!res.error) {
            this.setState({generatedInvoice: res.doc});
        }
    }

    componentWillMount() {
        this.loadInvoiceDetail();
    }

    updateInvoice = async(invoiceGeneratedRecordId) => {
        const { invoiceId } = this.props;
        let x = await Request.removeStudentFromInvoice({invoiceId, invoiceGeneratedRecordId});

        if (!x.error) {
            notification.success({
                message: 'Invoice updated successfully'
            });
            this.onClose();
        } else {
            notification.error({
                message: 'Error Saving',
                description: x.msg
            })
        }
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    render() {
        const {dispatch} = this.props
        const {
        form: {getFieldDecorator, setFieldsValue}
        } = this.props
        const {generatedInvoice} = this.state;

        return (
            <Drawer
                title={
                    <div>
                        {'Invoice '} {generatedInvoice.invoiceNumber}
                        <a onClick={this.onClose} style={{float: 'right', color: 'black'}}>
                            <Icon type={'close'}/>
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    <div className='ant-table ant-table-small ant-table-bordered ant-table-scroll-position-left ant-table-layout-fixed'>
                        <div className='ant-table-content'>
                            <div className='ant-table-scroll'>
                                <table className='ant-table-fixed' style={{width: '900px'}}>
                                    <thead className='ant-table-thead'>
                                        <tr>
                                            <th className='ant-table-row-cell-break-word'>Action</th>
                                            <th className='ant-table-row-cell-break-word'>Student Name</th>
                                            <th className='ant-table-row-cell-break-word'>Intitute Id</th>
                                            <th className='ant-table-row-cell-break-word'>Course Name</th>
                                            <th className='ant-table-row-cell-break-word'>Tution Fee</th>
                                            <th className='ant-table-row-cell-break-word'>Commission</th>
                                            <th className='ant-table-row-cell-break-word'>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody className='ant-table-tbody'>
                                        {
                                            generatedInvoice.invoices ?
                                            generatedInvoice.invoices.map((invoice, index) => {
                                                return  (
                                                    <tr key={index}>
                                                        <td className='ant-table-row-cell-break-word'>
                                                        <Tooltip title="Withdraw Student">
                                                            &nbsp;<Button
                                                                loading={false}
                                                                className={styles.btn}
                                                                onClick={() => {this.updateInvoice(invoice.invoiceGeneratedRecordId)}}
                                                                shape="circle"
                                                                icon="close"
                                                                />
                                                            </Tooltip>
                                                        </td>
                                                        <td className='ant-table-row-cell-break-word'>{invoice.studentName}</td>
                                                        <td className='ant-table-row-cell-break-word'>{invoice.instituteStudentId}</td>
                                                        <td className='ant-table-row-cell-break-word'>{invoice.courseName}</td>
                                                        <td className='ant-table-row-cell-break-word'>{invoice.currency} {invoice.tutionFee}</td>
                                                        <td className='ant-table-row-cell-break-word'>{invoice.commissionFromCourse}{invoice.commissionTypeFrom == 'Percentage'?'%':'Flat'}</td>
                                                        <td className='ant-table-row-cell-break-word'>{invoice.currency} {invoice.commissionTotal.toFixed(2)}</td>
                                                    </tr>
                                                )
                                            })                    
                                            :null
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Card>
            </Drawer>
        )
    }
}
  
const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InvoiceStudentList)